export const NTH_CHILD_QUERY_REGEX = /^(-)?(\d*)?n$/; // eslint-disable-line unicorn/no-unsafe-regex
